import { styled } from "@mui/material"
import ConventionTime from "components/conventions/ConventionTime"

const ConventionCardDateTime = styled(ConventionTime)(({ theme }) => ({
  ...theme.typography.paragraphRegular,
  color: theme.palette.gray.darker,
})) as typeof ConventionTime

export default ConventionCardDateTime
